import { Component, ElementRef, Input, OnInit, ViewChild, LOCALE_ID, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { DocTypeService } from 'src/app/services/doc-type.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { DatePipe, formatDate } from '@angular/common';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: 'app-training-certificate',
  templateUrl: './training-certificate.component.html',
  styleUrl: './training-certificate.component.scss'
})
export class TrainingCertificateComponent implements OnInit {

  @ViewChild('certificateElement') certificateElement?: ElementRef
  @ViewChild('ngxPrintButton') ngxPrintButton?: ElementRef<HTMLButtonElement>


  @Input() editFlag: boolean = false
  @Input() userTesting: boolean = false
  @Input() download: boolean = false
  @Input() email: string = '';
  @Input() courseId: any = ''
  @Input() certType: number = 1; // 1 => Attendance | 2 => Assessment | 3 => Transcript
  @Input() assessmentId: string = '';
  @Input() currentSession: any;

  certificateDate: any = {
    description: ''
  }
  courseData: any
  loader: boolean = false
  sessions: any
  assessments: any
  assessmentData: any
  assessmentResultData: any
  gradeData: any
  percentageCriteria:any
  assessmentTypeData: any
  userScore: number = 85;

  description: any
  editing: boolean = false;
  editInitail: boolean = false
  hasMinistry: boolean = false;
  correctMinistry: any
  inCorrectMinistry: any
  userData: any
  staticFileUrl = GlobalConstants.staticFilesURL;
  totalHours:any = 0;
  previewCorrect :any = [
    {
      "_id": "656eeb6725f19e97db08fec4",
      "label": "وزارة الموارد البشرية والتنمية الاجتماعية",
      "id": 476,
      "icon": "/public/ous/1acfe46bf8f205e35e47225723a7fe7c.png",
      "depth": 2,
      "questioncount": 1
    },
    {
      "_id": "656edf2b25f19e97db07ddd4",
      "label": "وزارة السياحة",
      "id": 313,
      "icon": "/public/ous/dcf135499df6f642d0d136427c21d7e8.png",
      "depth": 2,
      "questioncount": 1
    },
    {
      "_id": "656ed71625f19e97db070732",
      "label": "المؤسسة العامة للتأمينات الإجتماعية",
      "id": 208,
      "icon": "/public/ous/747dfae850834929817fbb29913bf35a.png",
      "depth": 2,
      "questioncount": 1
    },
  ];

  previewIncorrect :any = [
    {
      "_id": "65240ece00e319a6e26e2133",
      "label": "وزارة التجارة",
      "id": 1,
      "icon": "/public/ous/971b26a3b4ed0580ca35276e75483c3e.png",
      "depth": 2,
      "questioncount": 5
    },
    {
      "_id": "656ef84f25f19e97db09f11e",
      "label": "المديرية العامة للجوازات",
      "id": 709,
      "icon": "/public/ous/d01827e242d32cbc8891fde008f40608.png",
      "depth": 2,
      "questioncount": 1
    },
    {
      "_id": "656ed92325f19e97db073670",
      "label": "هيئة الزكاة والضريبة والجمارك",
      "id": 249,
      "icon": "/public/ous/97c874b5d96d323e3a904144fb316835.png",
      "depth": 2,
      "questioncount": 3
    },
    {
      "_id": "656ee0b225f19e97db07f66c",
      "label": "وزارة الاستثمار",
      "id": 322,
      "icon": "/public/ous/77830228ae01bfc440f47f80bc69a738.png",
      "depth": 2,
      "questioncount": 1
    },
    {
      "_id": "656ef84f25f19e97db09f11e",
      "label": "أسئلة عامة عن وزارة الاستثمار",
      "id": 893,
      "icon": "/public/ous/2b4889b44b5e6c943c532252de73a603.png",
      "depth": 2,
      "questioncount": 1
    }
  ];

  barChartOptions = {
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
            family: 'SSTArabic'
          }
        },
        display: false
      }
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 12,
            family: 'SSTArabic'
          },
          color :'gray',
          autoSkip: false, // Keeps all labels
          maxTicksLimit: 10, // Limits number of visible labels
          maxRotation: 90,
        }
      },
      y: {
        ticks: {
          font: {
            size: 12,
            family: 'SSTArabic'
          },
            color :'gray',
          stepSize: 1
        }
      }
    }
  };
  graphData:any;
  graphLabels:any;
  graphDatas:any;


  //Constructor
  constructor(
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private fb: FormBuilder,
    @Inject(LOCALE_ID) private locale: string
    // private location: Location,
    // private docService: DocTypeService
  ) { }

  ngOnInit() {
    this.editInitail = this.editFlag
    
    // Initialize userData with values from localStorage if available
    const username = localStorage.getItem('username') || '';
    const gender = localStorage.getItem('gender') || 'ذكر';
    this.userData = { name: username, email: this.email, gender: gender }

    if (this.courseId != ''){
      Promise.all([
        this.getCourseData()
      ])
    }
    
    if (this.assessmentId != ''){
      this.editFlag = false;
      if (this.userTesting)
      {
        this.userData = { name: localStorage.getItem('username') || '', email: this.email, gender: localStorage.getItem('gender') || 'ذكر' };
        this.getAssessmentType().then(() => {
          this.fetchAssessment()
        });
      }
      else {
        this.getAssessmentType().then(() => {
          this.fetchAssessmentResult().then(() => {
            this.fetchAssessment().then(() => {
              if (this.download)
              {
                const print = new Event('print');
                this.printCertificate(print);
              }
            })
          });
        });
      }
    }
  }

  translate(value: string) {
    const pipe: TranslatorPipe = new TranslatorPipe();
    return pipe.transform(value);
  }

  async getCourseData() {
    if (this.courseId) {
      try {

        this.loader = true
        let data: any = {
          id: this.courseId,
          email: this.userData?.email
        }

        if (this.editFlag == false) {
          data.email = this.userData?.email
          data.userFlag = true
        }


        const res = await this.dataService.postData(`course/certificate/`, data);

        if (res.error) {
          console.log(res.msg);
          return;
        }

        if (!res.data[0].certificate) {
          this.loader = false
          return
        }

        this.certificateDate = res.data[0].certificate
        
        this.courseData = res.data[0]
        if (!this.certificateDate.description || this.certificateDate.description == '') {
          this.certificateDate.description = this.translate('Certificate Default')
        }

        if (this.editFlag == false) {
          this.sessions = this.certificateDate?.session?.filter((e: any) => e.details.sessionType != 'Assessment' && e.details.sessionType != 'Certificate' && e.visible == true)
          this.assessments = this.certificateDate?.session?.filter((e: any) => e.details.sessionType == 'Assessment' && e.visible == true)
          this.description = this.formatString(this.certificateDate.description, this.userData.name, this.courseData.title)
          this.assessments.map(async (item: any) => {
            item

            let res = await this.dataService.getData(`assessment/id/${item?.details?.assessmentId}`);

            if (res.error) return

            let result = item?.details?.assessmentResult[item?.details?.assessmentResult.length - 1];
            let percentage = (result.score / result.totalmarks) * 100;
            let grade = this.getGradeTitle(res.data.percentageCriteria, percentage)

            item.details.grade = grade ? grade : '-'
          })
        } else {
          this.sessions = this.certificateDate?.session?.filter((e: any) => e.details.sessionType != 'Assessment' && e.details.sessionType != 'Certificate')
          this.assessments = this.certificateDate?.session?.filter((e: any) => e.details.sessionType == 'Assessment')
        }

        this.totalHours = this.calculateTotalHours(this.certificateDate.session).toFixed(2)
        console.log("this.sessions",this.sessions);

        this.loader = false

      } catch (e: any) {
        console.log(e)
      }
    }
  }


  calculateTotalHours(sessions: any[]): number {
    let totalHours = 0;

    sessions.forEach(session => {
        const details = session.details;

        if (details.sessionType === 'Online' || details.sessionType === 'Onsite') {
            const startTimeParts = details.start_time.split(':');
            const endTimeParts = details.end_time.split(':');

            const startDate = new Date();
            const endDate = new Date();

            startDate.setHours(parseInt(startTimeParts[0]), parseInt(startTimeParts[1]));
            endDate.setHours(parseInt(endTimeParts[0]), parseInt(endTimeParts[1]));

            const diffInMilliseconds = endDate.getTime() - startDate.getTime();
            const diffInHours = diffInMilliseconds / (1000 * 60 * 60);

            totalHours += diffInHours;
        }
    });

    return totalHours;
}

  async getAssessmentType() {
    try {
      this.loader = true
      let postData:any = {
        'assessmentId':this.assessmentId,
        'email':this.userData.email,
        'userTesting': this.userTesting
      }
      let res = await this.dataService.postData(`assessment/ministry/certificate`,postData);
      
      if (res.error) {
        return;
      }
      this.assessmentTypeData = res.data;

      if (this.assessmentTypeData.length > 0)
      {
        this.hasMinistry = true;
        
        if (this.userTesting == false) {
          res.data.forEach((item: any) => {
            if (item._id === true) {
              this.correctMinistry = item.set;
            } else if (item._id === false) {
              this.inCorrectMinistry = item.set;
            }
          });
          this.correctMinistry = this.correctMinistry.filter((correctItem: { id: any; }) => {
            return !this.inCorrectMinistry.some((incorrectItem: { id: any; }) => incorrectItem.id === correctItem.id);
          });
        }

        if (this.userTesting) {
          this.inCorrectMinistry = this.previewIncorrect;
          this.correctMinistry = this.previewCorrect;
        }
        
        this.graphDatas  = this.pluckData(this.inCorrectMinistry);
        this.graphLabels = this.pluckLabels(this.inCorrectMinistry);
        this.graphData = this.getBarGraph();
      }
      else{
        this.hasMinistry = false;
      }
      this.loader = false
    } catch (e) {

    }
  }

  async fetchAssessmentResult() {
    try {
      this.loader = true
      let res = await this.dataService.getData(`assessment-result/email/${this.assessmentId}/${this.userData.email}`);
      if (res.error) {
        return;
      }
      this.assessmentResultData = res.data;
      if (!this.userTesting)
      {
        if (this.assessmentResultData.externalName)
        {
          this.userData.name = this.assessmentResultData.externalName;
        }
        if (this.assessmentResultData.externalGender)
        {
          this.userData.gender = this.assessmentResultData.externalGender;
        }
      }
      this.loader = false
    } catch (e) {

    }
  }

  async fetchAssessment() {
    try {
      this.loader = true
      let res = await this.dataService.getData(`assessment/id/${this.assessmentId}`);
      if (res.error) {
        return;
      }
      this.assessmentData = res.data;
      if (this.userTesting == false)
      {
        this.userScore = Math.floor((this.assessmentResultData.score / this.assessmentResultData.totalmarks) * 100);
      }
      this.gradeData = this.getGradeData(res.data.percentageCriteria, this.userScore)
      this.percentageCriteria = res.data.percentageCriteria;
      console.log("this.percentageCriteria",this.percentageCriteria);
      this.loader = false
    } catch (e) {

    }
  }

  changeGrade(score:any) {
    this.userScore = score;
    this.gradeData = this.getGradeData(this.percentageCriteria, this.userScore)
  }

  getGradeTitle(criteria: any[], score: any) {
    for (let i = 0; i < criteria.length; i++) {
      if (score >= criteria[i].from && score < criteria[i].to) {
        return criteria[i].title;
      }
    }
    let max = criteria.sort((a: any, b: any) => b.to - a.to)[0]
    if (score >= max.to) {
      return max.title;
    }
    return null; // Return null if score is out of range
  }

  getGradeData(criteria: any[], score: any) {
    for (let i = 0; i < criteria.length; i++) {
      if (score >= criteria[i].from && score < criteria[i].to) {
        return criteria[i];
      }
    }
    let max = criteria.sort((a: any, b: any) => b.to - a.to)[0]
    if (score >= max.to) {
      return max;
    }
    return null; // Return null if score is out of range
  }

  async setCertificate() {
    try {
      this.loader = true
      let data: any = {
        _id: this.courseId,
        certificate: {
          description: this.certificateDate.description,
          session: this.getSessions()
        }
      }

      let res = await this.dataService.postData('course', data, 'PUT')


      if (!res.error) {
        this.loader = false
      }


    } catch (error) {
      console.log(error)
    }
  }

  formatString(input: string, name: string, trainingName: string): string {
    return input
      .replace(/\{اسم\}/g, `<span class="blue-italic">${name}</span>`)
      .replace(/\{اسم التدريب\}/g, `<span class="blue-italic">${trainingName}</span>`)
      .replace(/\{الساعات\}/g, `(${this.totalHours})`)
      .replace(/\{من التاريخ\}/g, `${formatDate(this.courseData?.start_date, "dd-MM-yyyy", this.locale)}`)
      .replace(/\{حتى التاريخ\}/g, `${formatDate(this.courseData?.end_date, "dd-MM-yyyy", this.locale)}`)
      .replace(/\n/g, '<br>');
  }

  formatAssessmentName(input: string): string {
    return input
      .replace(/\{الاسم\}/g, `<span class="blue-italic">${this.userData.name}</span>`)
      .replace(/\{ذكر\s*\|\s*أنثى\s*\}/g, `<span class="blue-italic">${ (this.userData.gender == 'ذكر') ? this.translate('CertGrettingMale') : this.translate('CertGrettingFemale')}</span>`)
      .replace(/\{اسم الاختبار\}/g, `<span class="blue-italic">${this.assessmentData.name}</span>`)
      .replace(/\{اسم التدريب\}/g, `<span class="blue-italic">${this.courseData?.title}</span>`)
      .replace(/\n/g, '<br>');
  }

  formatAttendaceCertificate(input: string): string {
    return input
      .replace(/\{الاسم\}/g, `<span class="blue-italic">${this.userData.name}</span>`)
      .replace(/\{اسم التدريب\}/g, `${this.courseData?.title}`)
      .replace(/\{الساعات\}/g, `(${this.totalHours})`)
      .replace(/\{من التاريخ\}/g, `${formatDate(this.courseData?.start_date, "dd-MM-yyyy", this.locale)}`)
      .replace(/\{حتى التاريخ\}/g, `${formatDate(this.courseData?.end_date, "dd-MM-yyyy", this.locale)}`)
      .replace(/\{لها\s*\|\s*له\s*\}/g, `${ (this.userData.gender == 'ذكر') ? this.translate('AttendanceCertLahamMale') : this.translate('AttendanceCertLahamFemale')}`)
      .replace(/\{حضر\s*\|\s*حضرت\s*\}/g, `${ (this.userData.gender == 'ذكر') ? this.translate('AttendanceCertHazorMale') : this.translate('AttendanceCertHazorFemale')}`)
      .replace(/\{ذكر\s*\|\s*أنثى\s*\}/g, `<span class="blue-italic">${ (this.userData.gender == 'ذكر') ? this.translate('AttendanceCertGrettingMale') : this.translate('AttendanceCertGrettingFemale')}</span>`)
      .replace(/\n/g, '<br>');
  }

  getSessions() {
    let sessions = this.sessions.map((item: any) => {
      return {
        id: item.id,
        visible: item.visible,
      }
    })

    let ass = this.assessments.map((item: any) => {
      return {
        id: item.id,
        visible: item.visible,
      }
    })
    return [...sessions, ...ass]


  }

  getScore(obj: any) {
    if (!obj) return 0
    let number = (obj?.score / obj?.totalmarks) * 100
    return number.toFixed(0)
  }

  handlePreview(flag: boolean) {
    if (this.certType == 3){
      this.setCertificate();
    }
    this.editing = flag
    this.editFlag = flag
    this.getCourseData()
  }

  //print
  async printCertificate(event: Event) {
    event.stopPropagation(); // Stop event propagation
    // Wait for the certificate to finish rendering (also covers the ?download=true flow)
    setTimeout(() => this.printWithNgx(), 500);
  }

  // Prints through ngx-print, which copies the certificate HTML into a print window
  printWithNgx() {
    const section = this.certificateElement?.nativeElement as HTMLElement | undefined;
    const sheet = section?.querySelector('.cert-scale') as HTMLElement | null;
    const button = this.ngxPrintButton?.nativeElement;
    if (!section || !sheet || !button) return;

    // Fixed-design certificates scale with width, so their height/width ratio is constant;
    // pick the widest print width that still fits the certificate on one A4 page.
    // Set as a % of the page width, not mm: mobile Chrome lays the print out at its own
    // viewport width and scales it onto the paper, so mm sizes overflow the page there
    if (this.certType != 3) {
      const landscape = sheet.classList.contains('cert-landscape');
      const margin = sheet.classList.contains('cert-full-bleed') ? 0 : 10; // matches the @page margins
      const [pageW, pageH] = (landscape ? [297, 210] : [210, 297]).map(size => size - margin * 2);
      const ratio = sheet.scrollHeight / sheet.clientWidth;
      // 0.98 keeps rounding from spilling a sliver onto a second page
      // (the full-bleed assessment certificate is already locked to one page in CSS)
      const safety = margin ? 0.98 : 1;
      const widthPercent = Math.min(1, pageH / pageW / ratio) * safety * 100;
      sheet.style.setProperty('--print-width', `${widthPercent.toFixed(2)}%`);
    }

    // ngx-print copies HTML only, so swap chart canvases for images while it copies
    const swaps = Array.from(section.querySelectorAll('canvas')).map(canvas => {
      const img = document.createElement('img');
      img.src = canvas.toDataURL('image/png');
      img.style.width = '100%';
      const display = canvas.style.display;
      canvas.style.display = 'none';
      canvas.after(img);
      return { canvas, img, display };
    });

    button.click();

    swaps.forEach(({ canvas, img, display }) => {
      img.remove();
      canvas.style.display = display;
    });
    sheet.style.removeProperty('--print-width');
  }

  getBarGraph(): any {
    return {
      labels: this.labelmaker(this.graphLabels),
      datasets: [
        {
          backgroundColor: '#1e90ff',
          label: 'للاختبار المهاري للاختبار المهاري',
          data: this.graphDatas,
        }
      ]
    };
  }

  labelmaker(inputArray: string[]): string[][] {
    const result: string[][] = [];
    inputArray.forEach(item => {
        if (item.length <= 30) {
            result.push([item]);
        } else {
            result.push(["..." + item.substring(0, 30)]);
        }
    });
    return result;
  }

  pluckLabels(data: any[]): string[] {
    return data.map(item => item.label);
  }

  pluckData(data: any[]): string[] {
    return data.map(item => item.questioncount);
  }

}
